module.exports = __webpack_public_path__ + "img/Dee.42d70c03.png";